import { getGrocery, getTopAds } from "@/services";
import { useMount } from "ahooks";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import useAppStore from "../../context/store";
import { tokenFieldName, uidFieldName } from "../uid";

/**缓存的页面需要在客户端做的特殊处理 */
export const usePageCache = () => {
  const { refreshUser, isPageCache, adTopConfig } = useAppStore((s) => ({
    refreshUser: s.refreshUser,
    isPageCache: s.isPageCache,
    adTopConfig: s.adTopConfig,
  }));

  const router = useRouter();

  useMount(async () => {
    const checkUid = Cookies.get(uidFieldName) || Cookies.get(tokenFieldName);

    if (isPageCache) {
      // cookie存在用户信息，则获取用户信息
      if (checkUid) {
        refreshUser();
      } else {
        //未登录用户，改变userReady状态
        useAppStore.setState({
          user: null,
          userReady: true,
        });
      }
    }

    if (isPageCache) {
      const [ads, globalNotice] = await Promise.all([
        // 获取顶部广告位置
        getTopAds({
          url: router.asPath,
          adTopConfig,
        }),
        // 获取全局通知配置
        getGrocery("global-notice"),
      ]);

      useAppStore.setState({
        ads,
        globalNotice,
      });
    }
  });
};
